import { Children, PropsWithChildren } from 'react';

import { isSlot } from '../../../core/utils/is-slot.js';
import { XYChartAnnotationsConfigProps } from '../context/XYChartAnnotationsConfig.context.js';
import { Marker } from '../slots/Annotations/Marker.js';
import { AnnotationsTooltip } from '../slots/Annotations/Tooltip.js';
import { Track } from '../slots/Annotations/Track.js';

export const iterateXYChartAnnotations = ({
  children,
  ...remaining
}: PropsWithChildren<XYChartAnnotationsConfigProps>) => {
  const annotations: XYChartAnnotationsConfigProps = { ...remaining };

  Children.forEach(children, (child) => {
    if (isSlot(child, Track)) {
      annotations.tracksConfig = child.props;
    } else if (isSlot(child, Marker)) {
      annotations.markersConfig = child.props;
    } else if (isSlot(child, AnnotationsTooltip)) {
      const { children, hidden } = child.props;
      annotations.tooltip = {
        template: children,
        hidden: hidden ?? false,
      };
    }
  });

  return annotations;
};
